var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-scroll-y-transition',{attrs:{"mode":"out-in","hide-on-leave":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }